import { Directive, effect, ElementRef, HostListener, inject, input, InputSignal } from '@angular/core';

/**
 * Ajuste la largeur d'un input a son contenu (en `ch`), pour qu'un element place
 * juste apres (ex : une unite) suive la valeur saisie.
 * La valeur bindee est passee en parametre pour recalculer la largeur quand elle
 * change depuis le modele ; la saisie clavier est suivie via l'evenement `input`.
 */
@Directive({
  selector: 'input[appAutoWidth]',
})
export class AutoWidth {
  appAutoWidth: InputSignal<unknown> = input<unknown>();

  private readonly element: HTMLInputElement = inject(ElementRef<HTMLInputElement>).nativeElement;

  constructor() {
    effect(() => this.resize(String(this.appAutoWidth() ?? '')));
  }

  @HostListener('input')
  onInput(): void {
    this.resize(this.element.value);
  }

  private resize(value: string): void {
    this.element.style.width = `${Math.max(value.length, 1)}ch`;
  }
}
